import { useQuery } from "@tanstack/react-query";
import { useScope } from "@state/scopeContext.lib";
import { rulesContractClient } from "@api/rules.api";

interface NormalizedDescriptionsData {
    normalizedDescriptions: Array<{
        normalizedDescriptionId: string;
        normalizedDescription: string;
        sampleBankDescription: string | null;
    }>;
    mergedToCanonicalMap: Record<string, string>;
}

const EMPTY_RESULT: NormalizedDescriptionsData = {
    normalizedDescriptions: [],
    mergedToCanonicalMap: {},
};

export function useNormalizedDescriptions() {
    const { workspaceId } = useScope();

    return useQuery({
        queryKey: ["normalized-descriptions", workspaceId],
        queryFn: async (): Promise<NormalizedDescriptionsData> => {
            if (!workspaceId) {
                return EMPTY_RESULT;
            }

            const response =
                await rulesContractClient.getNormalizedDescriptions({
                    params: { workspaceId },
                    query: {},
                });

            if (response.status === 200) {
                return {
                    normalizedDescriptions:
                        response.body.normalizedDescriptions,
                    mergedToCanonicalMap:
                        response.body.mergedToCanonicalMap ?? {},
                };
            }
            return EMPTY_RESULT;
        },
        enabled: !!workspaceId,
    });
}
